import { createContext, useState, useEffect } from 'react';

const todayISO = new Date().toISOString().split('T')[0];

const VisitorContext = createContext();

export const VisitorProvider = ({ children }) => {
  const [visitors, setVisitors] = useState(JSON.parse(localStorage.getItem('visitors')) || []);
  const [search, setSearch] = useState("");
  const [visitLocation, setVisitLocation] = useState(localStorage.getItem('visitLocation') || "");
  const [visitLocationId, setVisitLocationId] = useState(Number(localStorage.getItem('visitLocationId')) || null);
  const [visitDate, setVisitDate] = useState(localStorage.getItem('visitDate') || todayISO);

  const addNewVisitor = (visitor) => {
    setVisitors((prevVisitors) => ([visitor, ...prevVisitors]));
  };

  const editVisitor = (data) => {
    setVisitors(prevVisitors => prevVisitors.map(visitor => visitor.id === data.id ? { ...data } : visitor))
  }

  const deleteVisitor = (id) => {
    setVisitors(prevVisitors => prevVisitors.filter(visitor => visitor.id !== id))
  }

  const clear = () => {
    setVisitors([])
  }

  const clearAll = () => {
    setVisitors([]);
    setSearch('');
    setVisitLocation('');
    setVisitLocationId(null);
    setVisitDate(todayISO);
  };

  const markGuardianMissing = (guardianId) => {
    if (!guardianId) return;
    setVisitors(prev => prev.map(v =>
      (v.visitor_is_minor && v.guardian_id === guardianId)
        ? {
            ...v,
            guardian_id: '',
            guardian_first_name: '',
            guardian_last_name: '',
            guardian_email: '',
            guardian_phone: '',
            guardian_missing: true,
          }
        : v
    ));
  };

  const clearGuardianIfOrphaned = (guardianId, excludeMinorId) => {
    if (!guardianId) return;
    setVisitors(prev => {
      const stillHasMinors = prev.some(
        v => v.visitor_is_minor && v.guardian_id === guardianId && v.id !== excludeMinorId
      );
      if (stillHasMinors) return prev;
      return prev.map(v =>
        v.id === guardianId ? { ...v, person_is_guardian: false } : v
      );
    });
  };

  useEffect(() => {
    localStorage.setItem('visitors', JSON.stringify(visitors));
  }, [visitors]);

  useEffect(() => {
    localStorage.setItem('visitLocation', visitLocation);
  }, [visitLocation]);

  useEffect(() => {
    localStorage.setItem('visitLocationId', visitLocationId ?? '');
  }, [visitLocationId]);

  useEffect(() => {
    localStorage.setItem('visitDate', visitDate);
  }, [visitDate]);

  return (
    <VisitorContext.Provider value={{
      visitors,
      addNewVisitor,
      search,
      setSearch,
      editVisitor,
      deleteVisitor,
      clear,
      clearAll,
      markGuardianMissing,
      clearGuardianIfOrphaned,
      visitLocation,
      setVisitLocation,
      visitLocationId,
      setVisitLocationId,
      visitDate,
      setVisitDate,
    }}>
      {children}
    </VisitorContext.Provider>
  );
};

export default VisitorContext;